import { render, staticRenderFns } from "./TheProfileMenu.vue?vue&type=template&id=6bd7809d&scoped=true&"
import script from "./TheProfileMenu.vue?vue&type=script&lang=js&"
export * from "./TheProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileMenu.vue?vue&type=style&index=0&id=6bd7809d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7809d",
  null
  
)

export default component.exports